// utils/auth.js
import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const RobotIdKey = 'Admin-RobotId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 }) // 7天过期
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRobotId() {
  return Cookies.get(RobotIdKey)
}

export function setRobotId(robotId) {
  return Cookies.set(RobotIdKey, robotId, { expires: 7 }) // 7天过期
}

export function removeRobotId() {
  return Cookies.remove(RobotIdKey)
}


